module.exports = __webpack_public_path__ + "static/mockup-181868cfa65a0c236cff8d1da79165d2.png";